import React from "react";
import "../component/productTable.css";
import { useNavigate } from "react-router-dom";

const ProductTable = ({
  page,
  product,
  onEditProductClicked,
  onDeleteProductClicked,
  onInfoProductClicked,
}) => {
  const navigate = useNavigate()

  const editProduct = (product) => {
    onEditProductClicked(product);
  };

  const deleteProduct = (product) => {
    onDeleteProductClicked(product);
  };

  const seeInfoProduct = (product) => {
    onInfoProductClicked(product);
  };
  return (
    <div className="product-table-container">
      <table className="product-table">
        <thead>
          <tr>
            <th width="100px">No</th>
            <th>Produk</th>
            <th>Unit Produk</th>
            <th>Kategori Produk</th>
            <th>Rak Produk</th>
            <th>Hjb Produk</th>
            <th>Hjr Produk</th>
            <th>Harga Rekanan</th>
            <th>Stok Produk</th>

            <th width="150px">Actions</th>
          </tr>
        </thead>
        <tbody>
          {product.length > 0 ? (
            product.map((product, index) => (
              <tr
                key={index}
                onClick={() => {
                  navigate(`/daftar-produk/${product.product_id}`);
                }}
              >
                <td>{(page - 1) * 10 + index + 1}</td>
                <td>{product.product_name}</td>
                <td>{product.product_unit.product_unit_name}</td>
                <td>{product.product_category.product_category_name}</td>
                <td>{product.product_rack}</td>
                <td>{product.product_hjb_price_text}</td>
                <td>{product.product_hjr_price_text}</td>
                <td>{product.product_partner_selling_price_text}</td>
                <td>{product.product_total_stock}</td>
                <td>
                  <button
                    className="edit-doctor-specialist-button"
                    onClick={(evt) => {
                      evt.stopPropagation();
                      editProduct(product);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="detail-product-button"
                    onClick={(evt) => {
                      evt.stopPropagation();
                      seeInfoProduct(product);
                    }}
                  >
                    Kartu Stok
                  </button>
                  <button
                    className="delete-doctor-specialist-button"
                    onClick={(evt) => {
                      evt.stopPropagation();
                      deleteProduct(product);
                    }}
                  >
                    Hapus
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" style={{ textAlign: "center" }}>
                Data tidak tersedia
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ProductTable;
